var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckStockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.4526C16.36 13.6557 13.9474 16.6718 10.562 17.3458C8.91085 17.6749 7.19808 17.4742 5.66753 16.7723C4.13698 16.0703 2.86669 14.9028 2.03752 13.4361C1.20835 11.9694 0.862576 10.2782 1.04943 8.60333C1.23629 6.92845 1.94626 5.35527 3.07823 4.10781C5.40002 1.54786 9.32044 0.843164 12.5203 2.12442",
    stroke: "#68C230",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11914 9.17093L9.31896 12.3741L16.9985 4.0459",
    stroke: "#68C230",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStockIcon);
export default __webpack_public_path__ + "static/media/check_stock_icon.1be40fa9e5c6be761119af32b15d0255.svg";
export { ForwardRef as ReactComponent };